/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function Icon(props: IconProps) {
	const { color = 'primary' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-588 -695)">
					<path d="M603.406 708.861h-4.774L596.5 711l-2.132-2.139h-4.774c-.88 0-1.594-.716-1.594-1.6V696.6c0-.883.713-1.599 1.594-1.599h13.812c.88 0 1.594.717 1.594 1.6v10.662c0 .883-.714 1.6-1.594 1.6zm.531-12.262a.532.532 0 00-.531-.533h-13.812a.532.532 0 00-.532.533v10.663c0 .295.238.534.532.534h5.307l1.599 1.605 1.6-1.605h5.306a.532.532 0 00.532-.534v-10.663zm-2.656 3.732h-9.563a.532.532 0 010-1.067h9.563a.533.533 0 010 1.067zm-7.438 2.132h5.313a.533.533 0 010 1.066h-5.313a.532.532 0 010-1.066z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default Icon;
